export enum ValidationErrorParam {
  Max = 'max',
  Message = 'message',
  Min = 'min',
  RequiredLength = 'requiredLength',
}
